import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import { getData, postData } from '../../api/ApiRest';
import { Breadcrumb, FloatingLabel, Form, Modal } from 'react-bootstrap';
import LoadingComponent from '../../widgets/LoadingComponent';
import { useSelector } from 'react-redux';
import { FaArchive, FaCheck, FaCheckCircle, FaEye, FaSearch, FaUserSecret } from 'react-icons/fa';
import { formatDateddMMyyyyhhmm } from '../../widgets/DateTime';
import { formatNumber } from '../../widgets/FormatNumber';
import { FaXmark } from 'react-icons/fa6';

function RadianCorreoIndex() {
    // Función auxiliar para formatear al formato requerido por datetime-local
    const toDatetimeLocal = (date) => {
        const d = new Date(date);
        const pad = (n) => String(n).padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    };

    const [modalAuditoria, setModalAuditoria] = useState({
        ModalVisible: false, Titulo: ''
    });

    const fechaActual = new Date();
    fechaActual.setDate(fechaActual.getDate() - 15);

    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState([]);
    const [dataBuscar, setDataBuscar] = useState({
        desde: toDatetimeLocal(fechaActual),
        hasta: toDatetimeLocal(new Date()),
        correo: 'null',
        Proveedor: '',
        Documento: '',
        FormaPago: '',
        Prefijo: '',
        Procesados: '0'
    });
    const [correos, setCorreos] = useState([]);
    const [auditoria, setAuditoria] = useState([]);
    const [modalInformacion, setModalInformacion] = useState({
        ModalVisible: false,
        Titulo: ''
    });

    const infoUser = useSelector((state) => state.auth);

    useEffect(() => {

        const getInfoIndex = async () => {
            setLoading(true);

            await getData('api/Cliente/Radian/GetCorreosConfigRadian', {
                companyId: infoUser.CompanyId,
                correo: null
            }).then(response => {
                setCorreos(response.correos);

                setLoading(false);
            }, error => {
                console.log(error);
                setLoading(false);
            })
        }

        getInfoIndex();
    }, []);

    ///Obtenemos las fechas que se va a utilizar para sincronizar en el correo
    const obtenerFechaSincro = (correo = '') => {
        setLoading(true);

        getData('api/Cliente/Radian/GetFechasRadian', {
            companyId: infoUser.CompanyId,
            correos: correo
        }).then(response => {
            ///Si es igual a null, procede a asignarle una fecha actual menos 15 días hacía atrás
            if (response.companyConfigRadian.fechaUltSincro === 'null' || response.companyConfigRadian.fechaUltSincro === null) {
                const fecha = new Date();
                fecha.setDate(fecha.getDate() - 15);

                setDataBuscar({
                    desde: toDatetimeLocal(fecha),
                    correo: correo,
                    hasta: toDatetimeLocal(new Date())
                });
            } else { ///De lo contrario le asigna la ultima que se uso para sincronizar
                setDataBuscar({
                    desde: toDatetimeLocal(response.companyConfigRadian.fechaUltSincro),
                    correo: correo,
                    hasta: toDatetimeLocal(new Date())
                });
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    const getRadianCorreo = (event) => {
        event.preventDefault();

        setLoading(true);

        var dias = calcularDiferenciaDias(dataBuscar.desde, dataBuscar.hasta);

        if (dias >= 16) {
            alert('Debes de seleccionar un rango menor a 16 días');
            setLoading(false);
            return;
        }

        let objeto = {
            desde: dataBuscar.desde,
            hasta: dataBuscar.hasta,
            correo: dataBuscar.correo,
            documento: dataBuscar.Documento || '',
            proveedor: dataBuscar.Proveedor || '',
            formapago: dataBuscar.FormaPago || '',
            companyId: infoUser.CompanyId,
            prefijo: dataBuscar.Prefijo || '',
            procesados: dataBuscar.Procesados || '0'
        };

        postData('api/Cliente/Radian/Correos', {}, objeto)
            .then(data => {
                let facturas = data.resultado.flatMap(item => item.facturas || []);
                console.log(facturas);
                setResult(facturas);
                setLoading(false);
            }, error => {
                console.log(error);
                setLoading(false);
            })
    }

    const seleccionaRegistros = (valor) => {
        setResult(prev =>
            prev.filter(x => x.formaPago === 'Credito').map(item => ({
                ...item,
                selected: valor
            }))
        )
    }

    const agruparRegistros = async () => {
        const agrupado = result.filter(item => item.formaPago === 'Credito').reduce((acc, item) => {
            const correo = item.cuentaCorreo;

            if (!acc[correo]) {
                acc[correo] = {
                    correo,
                    cantidadProcesado: 0,
                    totalCorreos: 0
                };
            }

            acc[correo].totalCorreos += 1;

            if (item.selected)
                acc[correo].cantidadProcesado += 1;

            return acc;
        }, {})

        let valores = Object.values(agrupado);

        const response = await postData('api/Cliente/Radian/guardarAuditoriaCorreos', {
            companyId: infoUser.CompanyId
        }, valores);

        return response;
    }

    const procesarCorreos = async () => {
        let registros = result.filter(item => item.selected === true);

        //Validamos si a seleccionado algún registro
        if (registros.length === 0) {
            alert('Debes de seleccionar al menos un registro');
            return;
        }

        const resultado = await agruparRegistros();

        ///Si el resultado es verdadero, quiere decir que se guarda correctamente la info en la auditoria
        if (resultado.status === true) {
            for (let i = 0; i < registros.length; i++) {
                const item = registros[i];
                const cufe = item.cufe === '' ? item.cude : item.cufe;

                setResult(prev =>
                    prev.map((x, index) =>
                        x.cufe === cufe ? { ...x, loading: true } : x
                    )
                );

                await postData('api/Cliente/Radian/registrarCorreos', {}, item).then(response => {
                    setResult(prev =>
                        prev.map((x, index) =>
                            x.cufe === cufe ?
                                {
                                    ...x,
                                    status: response.estado[0].status,
                                    mensaje: response.estado[0].msj,
                                    loading: false
                                }
                                : x
                        )
                    )
                }, error => {
                    console.log(error);

                    setResult(prev =>
                        prev.map((x, index) =>
                            x.cufe === cufe ?
                                {
                                    ...x,
                                    status: false,
                                    mensaje: error,
                                    loading: false
                                }
                                : x
                        )
                    );
                })
            }
        }
    }

    const getAuditoria = async (correo) => {
        await getData('api/Cliente/Radian/GetCorreosConfigRadian', {
            companyId: infoUser.CompanyId,
            correo: correo
        }).then(response => {
            setAuditoria(response.list);
        }, error => {
            console.log(error);
        })
    }

    const calcularDiferenciaDias = (desde, hasta) => {
        if (!desde || !hasta) return 0;

        const fechaDesde = new Date(desde);
        const fechaHasta = new Date(hasta);

        const diffMs = fechaHasta - fechaDesde;

        return diffMs / (1000 * 60 * 60 * 24);
    }

    return (
        <div className='BodyComponent'>
            <Breadcrumb>
                <Breadcrumb.Item style={{ fontSize: 14 }} >Cliente</Breadcrumb.Item>
                <Breadcrumb.Item style={{ fontSize: 14 }} href="/Cliente/RadianIndex">RADIAN</Breadcrumb.Item>
                <Breadcrumb.Item style={{ fontSize: 14 }} active={true}>Correos RADIAN</Breadcrumb.Item>
            </Breadcrumb>

            <div className="d-flex gap-1">
                <Button variant='success' size='sm' onClick={() => procesarCorreos()} style={{ fontSize: 12 }}>
                    <FaArchive size={'0.8rem'} />
                </Button>
                <Button variant='warning' size='sm' style={{ fontSize: 12 }} onClick={() => {
                    setModalAuditoria({
                        ModalVisible: true,
                        Titulo: 'Visualizar configuración'
                    });
                }}>
                    <FaUserSecret size={'0.8rem'} />
                </Button>
            </div>

            <div className='row' style={{ marginTop: '5px' }}>
                {correos ?
                    <div className='col-md-4'>
                        <FloatingLabel
                            controlId='Correos'
                            label="Correos"
                            className="form-floating-sm mb-2"
                        >
                            <Form.Select
                                value={dataBuscar.correo}
                                onChange={event => {
                                    setDataBuscar({ ...dataBuscar, correo: event.target.value });

                                    //Validamos primeramente si es todos o si es correo por correo
                                    if (event.target.value !== 'null')
                                        obtenerFechaSincro(event.target.value);
                                }}
                                className="input-fecha-sm"
                            >
                                <option value="null">Todos</option>
                                {correos.map((item, key) =>
                                    <option key={key} value={item.correo}>{item.correo}</option>)}
                            </Form.Select>
                        </FloatingLabel>
                    </div> : null}

                {dataBuscar.correo !== 'null' ?
                    <>
                        <div className='col-md-2'>
                            <FloatingLabel
                                controlId="EmisionDesde"
                                label="Desde"
                                className="form-floating-sm mb-3"
                            >
                                <Form.Control
                                    size='sm'
                                    type="datetime-local"
                                    autoComplete='off'
                                    placeholder="Desde"
                                    value={dataBuscar.desde}
                                    onChange={value => {
                                        setDataBuscar({
                                            ...dataBuscar,
                                            desde: value.target.value
                                        });
                                    }}
                                    className="input-fecha-sm"
                                />
                            </FloatingLabel>
                        </div>
                        <div className='col-md-2'>
                            <FloatingLabel
                                controlId="EmisionHasta"
                                label="Hasta"
                                className="form-floating-sm mb-3"
                            >
                                <Form.Control
                                    size='sm'
                                    type="datetime-local"
                                    autoComplete='off'
                                    placeholder="Hasta"
                                    value={dataBuscar.hasta}
                                    onChange={value => {
                                        setDataBuscar({
                                            ...dataBuscar,
                                            hasta: value.target.value
                                        });
                                    }}
                                    className="input-fecha-sm"
                                />
                            </FloatingLabel>
                        </div>
                    </>
                    :
                    <>
                        <div className='col-md-2'>
                            <FloatingLabel
                                controlId="EmisionDesde"
                                label="Desde"
                                className="form-floating-sm mb-3"
                            >
                                <Form.Control
                                    size='sm'
                                    type="datetime-local"
                                    autoComplete='off'
                                    placeholder="Desde"
                                    value={dataBuscar.desde}
                                    onChange={value => {
                                        setDataBuscar({
                                            ...dataBuscar,
                                            desde: value.target.value
                                        });
                                    }}
                                    className="input-fecha-sm"
                                />
                            </FloatingLabel>
                        </div>
                        <div className='col-md-2'>
                            <FloatingLabel
                                controlId="EmisionHasta"
                                label="Hasta"
                                className="form-floating-sm mb-3"
                            >
                                <Form.Control
                                    size='sm'
                                    type="datetime-local"
                                    autoComplete='off'
                                    placeholder="Hasta"
                                    value={dataBuscar.hasta}
                                    onChange={value => {
                                        setDataBuscar({
                                            ...dataBuscar,
                                            hasta: value.target.value
                                        });
                                    }}
                                    className="input-fecha-sm"
                                />
                            </FloatingLabel>
                        </div>
                    </>
                }

                <div className='col-md-2'>
                    <FloatingLabel
                        controlId="Proveedor"
                        label="Proveedor"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="text"
                            autoComplete='off'
                            placeholder="Nit proveedor"
                            value={dataBuscar.Proveedor}
                            onChange={value => setDataBuscar({ ...dataBuscar, Proveedor: value.target.value })}
                            className="input-fecha-sm"
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-2'>
                    <FloatingLabel
                        controlId="Prefijo"
                        label="Prefijo"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="text"
                            autoComplete='off'
                            placeholder="Prefijo"
                            value={dataBuscar.Prefijo}
                            onChange={value => setDataBuscar({ ...dataBuscar, Prefijo: value.target.value })}
                            className="input-fecha-sm"
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-2'>
                    <FloatingLabel
                        controlId="Numero"
                        label="Número"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="number"
                            autoComplete='off'
                            placeholder="Número"
                            value={dataBuscar.Documento}
                            onChange={value => setDataBuscar({ ...dataBuscar, Documento: value.target.value })}
                            className="input-fecha-sm"
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-2'>
                    <FloatingLabel
                        controlId="FormaPago"
                        label="Forma pago"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Select
                            size='sm'
                            value={dataBuscar.FormaPago}
                            onChange={event => {
                                setDataBuscar({
                                    ...dataBuscar,
                                    FormaPago: event.target.value
                                })
                            }}
                            className="input-fecha-sm"
                        >
                            <option value="null">Todos</option>
                            <option value="Credito">Credito</option>
                            <option value="Contado">Contado</option>
                        </Form.Select>
                    </FloatingLabel>
                </div>

                <div className='col-md-2'>
                    <FloatingLabel
                        controlId="Procesado"
                        label="Correos procesados"
                        className="form-floating-sm mb-3"
                    >
                        <Form.Select
                            size='sm'
                            value={dataBuscar.Procesados}
                            onChange={event => {
                                setDataBuscar({
                                    ...dataBuscar,
                                    Procesados: event.target.value
                                })
                            }}
                            className="input-fecha-sm"
                        >
                            <option value="null">Todos</option>
                            <option value="0">No procesados</option>
                        </Form.Select>
                    </FloatingLabel>
                </div>

                <div className='col-md-2'>
                    <Button variant='primary' size='sm' type='button' onClick={getRadianCorreo} style={{ fontSize: 12 }}>
                        <FaSearch size={'0.8rem'} />
                    </Button>
                </div>

            </div>

            {<LoadingComponent Loading={loading} />}
            <div className='table-responsive mt-3'>
                <table className='table table-borderless table-hover'>
                    <thead>
                        <tr>
                            <th className='estilo-encabezado' style={{ fontSize: 10 }}>
                                #
                            </th>
                            <th className='estilo-encabezado' style={{ fontSize: 10 }}>
                                Prefijo
                            </th>
                            <th className='estilo-encabezado' style={{ fontSize: 10 }}>
                                Número
                            </th>
                            <th className='estilo-encabezado' style={{ fontSize: 10 }}>
                                Fecha emisión
                            </th>
                            <th className='estilo-encabezado' style={{ fontSize: 10 }}>
                                Fecha correo
                            </th>
                            <th className='estilo-encabezado' style={{ fontSize: 10 }}>
                                Proveedor
                            </th>
                            <th className='estilo-encabezado' style={{ fontSize: 10 }}>
                                Forma pago
                            </th>
                            <th className='estilo-encabezado' style={{ fontSize: 10 }}>
                                Total
                            </th>
                            <th className='estilo-encabezado' style={{ fontSize: 10 }}>
                                <button className='btn btn-sm btn-dark' type='button' title='Seleccionar todo' onClick={() => seleccionaRegistros(true)} onDoubleClick={() => seleccionaRegistros(false)}>
                                    <FaCheckCircle size={'0.8rem'} />
                                </button>
                            </th>
                            <th className='estilo-encabezado' style={{ fontSize: 10 }}>
                                Mensaje
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {result.map((item, index) => (
                            <tr key={index} style={{ fontSize: 10 }}>
                                <td className="text-center">
                                    {index + 1}
                                </td>
                                <td className="text-center" style={{ fontSize: 10, backgroundColor: item.formaPago === 'Procesado' ? '#d4edda' : null }}>
                                    {item.prefijo}
                                </td>
                                <td className="text-center" style={{ fontSize: 10, backgroundColor: item.formaPago === 'Procesado' ? '#d4edda' : null }}>
                                    {item.numeroDocumento}
                                </td>
                                <td className="text-center" style={{ fontSize: 10, backgroundColor: item.formaPago === 'Procesado' ? '#d4edda' : null }}>
                                    {formatDateddMMyyyyhhmm(item.fechaEmision)}
                                </td>
                                <td className="text-center" style={{ fontSize: 10, backgroundColor: item.formaPago === 'Procesado' ? '#d4edda' : null }}>
                                    {formatDateddMMyyyyhhmm(item.fechaCorreo)}
                                </td>
                                <td className="text-center" style={{ fontSize: 10, backgroundColor: item.formaPago === 'Procesado' ? '#d4edda' : null }}>
                                    {item.nitEmisor} - {item.nombreEmisor}
                                </td>
                                <td className="text-center" style={{ fontSize: 10, backgroundColor: item.formaPago === 'Procesado' ? '#d4edda' : null }}>
                                    {item.formaPago}
                                </td>
                                <td style={{ fontSize: 10, textAlign: 'right', backgroundColor: item.formaPago === 'Procesado' ? '#d4edda' : null }}>
                                    ${formatNumber(item.totalFactura)}
                                </td>
                                <td className='text-center' style={{ fontSize: 10, backgroundColor: item.formaPago === 'Procesado' ? '#d4edda' : null }}>
                                    {item.formaPago === 'Credito' ? (
                                        item.loading ? (
                                            <img
                                                alt="loading"
                                                src="/tav-loading.gif"
                                                style={{ width: 20 }}
                                            />
                                        ) : item.status !== undefined ? (
                                            item.status ? <FaCheck size={'1rem'} /> : <FaXmark size={'1rem'} />
                                        ) : (
                                            <Form.Check
                                                checked={item.selected}
                                                onChange={() =>
                                                    setResult(
                                                        result.map(p =>
                                                            p.cufe === item.cufe
                                                                ? { ...p, selected: !item.selected }
                                                                : p
                                                        )
                                                    )
                                                }
                                            />
                                        )
                                    ) : null}
                                </td>
                                <td className="text-center" style={{ fontSize: 9, backgroundColor: item.formaPago === 'Procesado' ? '#d4edda' : null }}>
                                    {item.mensaje}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <Modal
                show={modalInformacion.ModalVisible}
                size="xl"
                onHide={() => {
                    setModalInformacion({
                        ModalVisible: false, Titulo: ''
                    });

                    setAuditoria([]);
                }}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{modalInformacion.Titulo}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {auditoria.length > 0 ? <table className='table table-borderless table-hover'>
                        <thead>
                            <tr>
                                <th className="estilo-encabezado">
                                    Desde
                                </th>
                                <th className="estilo-encabezado">
                                    Hasta
                                </th>
                                <th className="estilo-encabezado">
                                    Total correos
                                </th>
                                <th className="estilo-encabezado">
                                    Correos procesados
                                </th>
                                <th className="estilo-encabezado">
                                    Correos no procesados
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {auditoria.map((item, index) => (
                                <tr key={index} style={{ fontSize: 12 }}>
                                    <td className="text-center">
                                        {formatDateddMMyyyyhhmm(item.desde)}
                                    </td>
                                    <td className="text-center">
                                        {formatDateddMMyyyyhhmm(item.hasta)}
                                    </td>
                                    <td className="text-center">
                                        {formatNumber(item.totalCorreos)}
                                    </td>
                                    <td className="text-center">
                                        {formatNumber(item.cantidadProcesados)}
                                    </td>
                                    <td className="text-center">
                                        {formatNumber(item.cantidadNoProcesadas)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table> : null}
                </Modal.Body>
            </Modal>

            <Modal
                show={modalAuditoria.ModalVisible}
                size="xl"
                onHide={() => {
                    setModalAuditoria({
                        ModalVisible: false, Titulo: ''
                    });
                }}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{modalAuditoria.Titulo}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {correos ?
                        <div className='table-responsive mt-3'>
                            <table className='table table-borderless table-hover'>
                                <thead>
                                    <tr>
                                        <th className='estilo-encabezado'>
                                            Correo
                                        </th>
                                        <th className='estilo-encabezado'>
                                            Ultima sincronización
                                        </th>
                                        <th className='estilo-encabezado'>
                                            Información
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {correos.map((item, index) => (
                                        <tr key={index} style={{ fontSize: 10 }}>
                                            <td className="text-center">
                                                {item.correo}
                                            </td>
                                            <td className="text-center">
                                                {formatDateddMMyyyyhhmm(item.ultSincro)}
                                            </td>
                                            <td className="text-center">
                                                <Button variant='warning'
                                                    size='sm'
                                                    style={{ fontSize: 12 }}
                                                    onClick={() => {
                                                        setModalInformacion({
                                                            ModalVisible: true,
                                                            Titulo: 'Información ' + item.correo
                                                        });

                                                        getAuditoria(item.correo);
                                                    }}>
                                                    <FaEye size={'0.8rem'} />
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div> : null}
                </Modal.Body>
            </Modal>

        </div>
    );
}

export default RadianCorreoIndex;